import { axiosLasta } from 'config';
import { buildResponseUnauthorizedErrorHandler } from 'utils/axiosHelper/axiosErrorHandlerHelper';

export const fetchAuthorizedPersonnelListByLocation = async (locationId) => {
    const response = await axiosLasta(`/client/access-personnel/location/${locationId}`, {
        handleResponseError: buildResponseUnauthorizedErrorHandler("You don't have permission to access Authorized People."),
    });
    return response?.data;
};

export const searchAuthorizedPersonnelFromLocationByFullname = async ({ locationId, fullName }) => {
    const url = `/client/access-personnel/authorized-person/search`;
    const response = await axiosLasta(url, {
        params: {
            locationId,
            fullName,
            limit: 100,
        },
        cache: {
            enabled: true,
            key: `client/access-personnel/authorized-person/search?locationId=${locationId}&fullname=${fullName}&limit=100`,
        },
    });
    return response?.data;
};
